import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import './MatchConfirmationModal.css'

/**
 * MatchConfirmationModal - Shows confirmation after accepting a match proposal
 * Provides quick navigation links to relevant pages
 */
export default function MatchConfirmationModal({ isOpen, onClose, matchData }) {
  const navigate = useNavigate()
  const { leagueId } = useParams()

  if (!isOpen) return null

  // Use league_id from matchData or URL params
  const league_id = matchData?.league_id || leagueId

  const handleNavigate = (path) => {
    navigate(path)
    onClose()
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content match-confirmation-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirmation-title"
      >
        <div className="modal-header">
          <h2 id="confirmation-title">✅ Match Scheduled!</h2>
          <button
            className="close-button"
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>

        <div className="modal-body">
          <p className="confirmation-message">
            Your match has been successfully scheduled.
          </p>

          <div className="navigation-links">
            <button
              className="btn btn-primary nav-link-btn"
              onClick={() => handleNavigate(`/leagues/${league_id}`)}
            >
              📋 League Landing
            </button>

            <button
              className="btn btn-primary nav-link-btn"
              onClick={() =>
                handleNavigate(`/leagues/${league_id}/availability`)
              }
            >
              📅 Weekly Calendar
            </button>

            <button
              className="btn btn-primary nav-link-btn"
              onClick={() =>
                handleNavigate(`/leagues/${league_id}/schedule-month`)
              }
            >
              🗓️ Monthly Calendar
            </button>

            <button
              className="btn btn-primary nav-link-btn"
              onClick={() =>
                handleNavigate(`/leagues/${league_id}/availability?tab=list`)
              }
            >
              📬 Opponent List
            </button>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
